var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help-detail markdown",domProps:{"innerHTML":_vm._s(_vm.content_html)}})
}
var staticRenderFns = []

export { render, staticRenderFns }